import React from 'react';

const FarmaciBancoIcon = (props) => {
  const fill = props ? props.color : '#294C76';
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9094 11.3319L11.3319 18.9094C13.4517 20.5128 16.4829 20.3482 18.4155 18.4155C20.3482 16.4829 20.5128 13.4517 18.9094 11.3319Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.2347 17.8852L17.8852 10.2347L9.76529 2.1148L2.1148 9.76529L10.2347 17.8852ZM7.87864 9.29289C8.26917 9.68342 8.26917 10.3166 7.87864 10.7071C7.48812 11.0976 6.85496 11.0976 6.46443 10.7071C6.07391 10.3166 6.07391 9.68342 6.46443 9.29289C6.85496 8.90237 7.48812 8.90237 7.87864 9.29289ZM10.7073 13.5355C11.0978 13.145 11.0978 12.5118 10.7073 12.1213C10.3167 11.7307 9.68357 11.7307 9.29304 12.1213C8.90252 12.5118 8.90252 13.145 9.29304 13.5355C9.68357 13.926 10.3167 13.926 10.7073 13.5355ZM10.7073 6.46452C11.0978 6.85505 11.0978 7.48821 10.7073 7.87874C10.3167 8.26926 9.68357 8.26926 9.29304 7.87874C8.90252 7.48821 8.90252 6.85505 9.29304 6.46452C9.68357 6.074 10.3167 6.074 10.7073 6.46452ZM13.5354 10.7071C13.9259 10.3166 13.9259 9.68342 13.5354 9.29289C13.1449 8.90237 12.5117 8.90237 12.1212 9.29289C11.7306 9.68342 11.7306 10.3166 12.1212 10.7071C12.5117 11.0976 13.1449 11.0976 13.5354 10.7071Z"
        fill={fill}
      />
      <path
        d="M1.09061 8.66816L8.66816 1.09061C6.54835 -0.512828 3.51714 -0.348208 1.58447 1.58447C-0.348209 3.51714 -0.512828 6.54835 1.09061 8.66816Z"
        fill={fill}
      />
    </svg>
  );
};

export default FarmaciBancoIcon;
